import { createSlice } from '@reduxjs/toolkit';

import { createSkuAccessoryMaterial, getAccessoryMaterial } from './api';

export const AccessoryManagementSlice = createSlice({

    name: 'AccessoryManagementPlatform',
    initialState: {
        isLoading: false,
        accessoryData : [],
        error: '',
        createSkuMaterialSuccess: false
    },

    reducers: {
      clear: (state, action) => {
        return {
          ...state,
          [action.payload.key]: action.payload.value
        }
      }
    },

    extraReducers: (builder) => {
        builder.addCase(getAccessoryMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getAccessoryMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.accessoryData = action.payload.data;
        })
        builder.addCase(getAccessoryMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(createSkuAccessoryMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(createSkuAccessoryMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.createSkuMaterialSuccess = true;
        })
        builder.addCase(createSkuAccessoryMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clear } = AccessoryManagementSlice.actions


export default AccessoryManagementSlice.reducer